module.exports = __webpack_public_path__ + "static/media/banner-go.18ca1aeb.jpg";